<template>
<div
	class="dropdown"
	@click.stop=""
>
	<!-- Open filter button -->
	<button
		type="button"
		class="btn btn-sm btn-link dropdown-toggle"
		data-bs-toggle="dropdown"
		aria-expanded="false"
		data-bs-auto-close="outside"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			class="bi bi-funnel"
			viewBox="0 0 16 16"
			fill="currentColor"
		>
			<path
				v-if="isDefault"
				d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"
			/>
			<path
				v-else
				d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"
			/>
		</svg>
	</button>
	<span v-if="buttonText.length > 0" class="">
		{{ buttonText }}
	</span>

	<!-- Filter dropdown form -->
	<form
		class="dropdown-menu pt-2 pb-2 ps-3 pe-2 shadow scrollable-dropdown"
		ref="filterPopup"
	>
		<div class="row justify-content-between align-items-center">
			<div class="col-auto order-first">
				<input
					ref="checkAll"
					class="form-check-input"
					type="checkbox"
					value="true"
					id="check-all"
					@change="(event) => setAllCriterias(event.target.checked)"
					checked
				>
			</div>
			<div class="col mx-auto text-center">
				<h6 class="dropdown-header px-auto mx-0">
					Фільтр
				</h6>
			</div>
			<div class="col-auto order-last">
				<button
					type="button"
					class="btn-close py-2 px-2"
					aria-label="Close"
					@click="hideFilterPopup()"
					style=""
				>
				</button>
			</div>
		</div>
		<div v-if="showSearch" class="row justify-content-between align-items-center">
			<div class="col-12">
				<input
					v-model.trim="searchPhrase"
					type="search"
					class="form-control form-control-sm ms-0 ms-xl-auto"
					style="max-width: 15rem;"
					placeholder="Фільтр параметрів"
					list="list-nodes"
					v-on:keydown.esc.stop="clearSearchPhrase()"
				/>
			</div>
		</div>
		
		<hr class="dropdown-divider">

		<template
			v-for="(el, index) in criteriasForm"
			:key="index"
		>
			<div v-if="el.show" class="form-check">
				<input
					class="form-check-input"
					type="checkbox"
					value="true"
					:id="el.id"
					v-model="el.checked"
					@change="onCheckCriteria"
				>
				<label class="form-check-label" :for="el.id">
					{{ el['title'] }}
				</label>
			</div>
		</template>
	</form>
</div>
</template>




<script>
import { Dropdown } from "bootstrap";


export default {
	props: {
		// Array of all criterias (Array[String,...])
		criterias: {
			type: Array,
			required: true,
			default: new Array(),
		},

		// Array of default checked criterias (Array[String,...])
		defaultChecked: {
			type: Array,
			required: false,
			default: new Array(),
		},

		buttonText: {
			type: String,
			required: false,
			default: '',
		},

		showSearch: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	emits: {
		checkedCriterias: value => Array.isArray(value), // Validation
	},

	setup() {
		return {}
	},

	data() {
		return {
			// Data for filter form
			criteriasForm: [],
			// For search input
			searchPhrase: '',	// search phrase
		}
	},

	watch: {
		// Update form on criterias update
		// (dangerous feature: criterias can update on table data update)
		// criterias(/*newCriterias*/) {
		// 	//console.log('newCriterias', newCriterias)
		//  this.initCriteriasForm()
		// 	this.setAllCriterias()
		// }

		criterias(newCriterias, oldCriterias) {
			if (newCriterias?.length !== oldCriterias?.length) {
				this.initCriteriasForm()
				this.setAllCriterias()
			}
		},

		// Update criterias on search phrase update
		async searchPhrase(newSearchPhrase/*, oldSearchPhrase*/) {
			// console.log('search phrase', newSearchPhrase)
			const rows = this.criteriasForm
			const search = newSearchPhrase.trim()

			// If search phrase is empty
			if (search === '') {
				this.criteriasForm.forEach(el => 
					el.show = true
				)
			// If search phrase is one word
			} else if (search.indexOf(' ') == -1) {
				// Filter items where any word starts with search phrase
				rows.forEach((el) => {
					// Split string to words
					const words = el.title.toLowerCase().split(/\s+/)
					// Check awery word
					const isAnyMatch = words.some((word) => 
						word.startsWith(search.toLowerCase())
					)
					//
					el.show = isAnyMatch
				})
			} else {
				rows.forEach((el) => 
					el.show = el.title.toLowerCase().includes(search.toLowerCase())
				)
			}
		}
	},

	created() {
		this.initCriteriasForm()
		this.setAllCriterias()
		// this.clearSearchPhrase()
	},

	mounted() {
		// Add listener on dropdown hide
		this.$refs.filterPopup?.closest('.dropdown').addEventListener('hide.bs.dropdown', this.clearSearchPhrase)
	},

	computed: {
		isDefault() {
			// console.log('criterias', this.criterias)
			// console.log('defaultChecked', this.defaultChecked)
			// console.log('criterias == defaultChecked', this.criterias.toString() == this.defaultChecked.toString())
			// return this.criterias.toString() == this.defaultChecked.toString()
			return this.criteriasForm.map((el) => el.checked ? el.title : undefined).toString()
				== this.defaultChecked.toString()
		},
	},

	methods: {
		initCriteriasForm() {
			this.criteriasForm.length = 0

			this.criterias.forEach((criteria) => {
				this.criteriasForm.push({
					id: criteria,
					title: criteria,
					checked: null,
					show: true,
				})
			})
		},

		onCheckCriteria() {
			// Actualize state of check all checkbox
			// If all criterias is check
			if (this.criteriasForm.every((el) => el.checked)) {
				this.$refs.checkAll.checked = true
			}
			// If all criterias is uncheck
			if (this.criteriasForm.every((el) => !el.checked)) {
				this.$refs.checkAll.checked = false
			}

			// Emit all checked criterias
			this.$emit(
				'checkedCriterias',
				this.criteriasForm.map((el) => el.checked ? el.title : null).filter((el) => el !== null)
			)
		},

		// Set value to all criteria checkboxes
		// If value == null then set default values
		setAllCriterias(value=null) {
			const checkedCriterias = []

			// for (const criteria of this.criterias) {
			this.criterias.forEach((criteria) => {
				let isChecked = true

				switch(value) {
					case null:
						isChecked = this.defaultChecked.length > 0 ?
							this.defaultChecked.includes(criteria) :
							true
						break;
					case true:
						isChecked = true
						break;
					case false:
						isChecked = false
						break;
					default:
						isChecked = true
				}
				

				this.criteriasForm.find((el) => el.id == criteria).checked = isChecked

				isChecked ? checkedCriterias.push(criteria) : null
			})

			this.$emit('checkedCriterias', checkedCriterias)

			// console.log('Criterias ', this.criteriasForm)
		},

		clearSearchPhrase() {
			this.searchPhrase = ''
		},

		hideFilterPopup() {
			(new Dropdown(this.$refs.filterPopup)).hide()
		},
	},

	beforeUnmount() {
		// Remove listener on dropdown hide
		this.$refs.filterPopup?.closest('.dropdown').removeEventListener('hide.bs.dropdown', this.clearSearchPhrase)
	},
}
</script>




<style scoped>
	.form-check-label {
		font-size: small;
		font-weight: 400;
	}

	.scrollable-dropdown {
		min-width: 15rem;
		max-height: calc(100vh - 220px); /* 100vh мінус трохи відступу зверху/знизу */
		overflow-y: auto;
		overflow-x: hidden;
	}
</style>